import React, {Component} from 'react';
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";
import {Button, InputGroupAddon, Tooltip} from "reactstrap";
import classnames from "classnames";
import InputNumber from "components/InputNumber";
import { connect } from 'react-redux';
import {setPlanRestrictionsModals} from "reducers/planRestrictionsModals/actions";
import QuestionSettingAvailable from "components/PlanRestrictionsModals/modals/QuestionSettingAvailable";

class SupplementMax extends Component {

  constructor(props) {
    super(props);
    this.state = {
      question: {
        supplementMax: props.question.supplementMax,
      },
      tooltip: false,
    };

    this.toggleTooltip = this.toggleTooltip.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  toggleTooltip() {
    this.setState({
      tooltip: !this.state.tooltip
    });
  }

  onChange(value){
    if (this.props.disabled) {
      this.props.setPlanRestrictionsModals(QuestionSettingAvailable.getName());
      return;
    }

    if(!value || value < 0){
      value = 0;
    }

    this.setState({
      question: {
        ...this.state.question,
        supplementMax: value
      }
    },
      () => this.props.handleUpdate(this.state.question)
    );
  }

  render() {
    let { question, tooltip } = this.state;

    return (
      <div
         id={"supplementMax-" + this.props.question.id}
         className={classnames({
           "min-w-0 float-left mr-1": true,
           "w-auto": !question.supplementMax,
           "w-100 w-lg-auto input-group": question.supplementMax
         })}
      >
        <InputGroupAddon addonType="prepend">
          <Button
            className={classnames({
              "btn-icon": true,
              "active": question.supplementMax > 0,
              "disabled": this.props.disabled
            })}
            color="secondary"
            onClick={() => {
              if(question.supplementMax === 0){
                this.onChange(1)
              }else{
                this.onChange(0)
              }
            }}
          >
            <i className="fak fa-comments-question-check-max" />
            <Tooltip
              delay={0}
              placement="top"
              isOpen={tooltip}
              target={"supplementMax-" + this.props.question.id}
              toggle={() => this.toggleTooltip()}
            >
              <FormattedMessage id="question.settings.supplementMax.button.tooltip"/>
            </Tooltip>
          </Button>
        </InputGroupAddon>
        {question.supplementMax > 0 && <InputNumber value={question.supplementMax} min={0} onChange={(value) => this.onChange(value)} className={this.props.disabled ? "not-active" : ""}/>}
      </div>
    )
  }
}

SupplementMax.defaultProps = {
  disabled: false
};

SupplementMax.propTypes = {
  question: PropTypes.shape({
    id: PropTypes.number.isRequired,
    supplementMax: PropTypes.number.isRequired,
  }).isRequired,
  handleUpdate: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default connect(null, {setPlanRestrictionsModals})(SupplementMax);
